import { v4 } from "uuid";

const STORAGE_KEY = "constellation_clientId";

/**
 * Returns the participant's client ID from localStorage. If none exists,
 * generates a new UUID and persists it immediately so all subsequent
 * requests in this session (and future sessions) use the same value.
 */
export function getClientId(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return stored;
    }
  } catch {
    // localStorage may be unavailable (e.g., private browsing on some browsers).
    // Fall through to generate a transient ID.
  }

  const id = v4();
  setClientId(id);
  return id;
}

/**
 * Persists the client ID to localStorage. Called when the server echoes back
 * the resolved ID (handles migration from cookie-only to header-based).
 */
export function setClientId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // Silently ignore — if localStorage is unavailable, the header will still
    // be sent for the lifetime of the page via the in-memory fallback.
  }
}
